<template>
  <gl-page icon-name="gr-farm" title="Overview">
    <div class="contentMain">
      <home-history class="contentMain__history" />
      <home-transactions class="contentMain__transactions" />
      <home-summary class="contentMain__summary" />
    </div>
  </gl-page>
</template>

<script>
import GlPage from '@gl/GlPage'
import HomeHistory from '@/components/Home/HomeHistory'
import HomeSummary from '@/components/Home/HomeSummary'
import HomeTransactions from '@/components/Home/HomeTransactions'

export default {
  name: 'Main',
  components: {
    HomeTransactions,
    HomeSummary,
    HomeHistory,
    GlPage,
  },
}
</script>

<style lang="scss" scoped>
.contentMain {
  @include grid;

  &__history {
    grid-column: 1 / -1;

    @media (min-width: $breakpoint-lg) {
      grid-column: 1 / -1;
    }
  }

  &__transactions {
    grid-column: 1 / -1;

    @media (min-width: $breakpoint-lg) {
      grid-column: 1 / 7;
    }
  }

  &__summary {
    grid-column: 1 / -1;

    @media (min-width: $breakpoint-lg) {
      grid-column: 7 / 13;
    }
  }
}
</style>
